var React = require('react');

function LeftChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.768 8.856L8.4 9.52L0.616 5.088L8.4 0.655999L8.768 1.328L2.168 5.088L8.768 8.856Z","fill":"#979CA4"}));
}

LeftChevronInline.defaultProps = {"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none"};

module.exports = LeftChevronInline;

LeftChevronInline.default = LeftChevronInline;
